
import SelectFinal from "@/components/input/Select";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { RadioGroup } from "@/components/ui/radio-group";
import { Textarea } from "@/components/ui/textarea";
import {
  handleFakeEventChange,
  handleFormChange,
} from "@/utils/formChange";
import { formInterface } from "@/interface/dataInterface";
import { RadioGroupItem } from "@radix-ui/react-radio-group";
import { Car, Truck, Bus } from "lucide-react";
import { Dispatch, FC, FormEvent, SetStateAction, useState } from "react";

// interface Props extends formInterface {
//   vehicleType: any;
//   setVehicleType: Dispatch<SetStateAction<any>>;
//   twoTanks: any;
//   setTwoTanks: any;
//   kmType: any;
//   setKmType: any;
//   makeValue: any;
//   setMakeValue: any;
//   primaryTankID: any;
//   setPrimaryTankID: any;
//   secondaryTankId: any;
//   setSecondaryTankId: any;
// }

const VehicleForm: FC<formInterface> = ({
  mode,
  formProp,
  setFormProp,
  otherData,
  setOtherData,
}) => {
  return (
    <>
      <div className="grid gap-2">
        <Label>Vehicle Type</Label>
        <RadioGroup
          id="type"
          value={formProp.type}
          onValueChange={(value: string) =>
            handleFormChange(handleFakeEventChange("type", value) as FormEvent<any>, setFormProp)
          }
          className="grid grid-cols-2 sm:grid-cols-4 gap-2"
        >
          {[
            { value: "car", label: "Car", icon: Car },
            { value: "truck", label: "Truck", icon: Truck },
            { value: "bus", label: "Bus", icon: Bus },
            { value: "motorcycle", label: "Motorcycle", icon: Truck },
          ].map(({ value, label, icon: Icon }) => {
            const isSelected = formProp.type === value;
            return (
              <div key={value} className="relative">
                <RadioGroupItem
                  value={value}
                  id={value}
                  className="peer hidden"
                />
                <Label
                  htmlFor={value}
                  className={`
                        px-4 py-2 rounded-md border text-sm font-medium cursor-pointer
                        ${isSelected ? "bg-white" : "bg-muted"} text-muted-foreground
                    `}
                >
                  <Icon className="h-4 w-4" />
                  {label}
                </Label>
              </div>
            );
          })}
        </RadioGroup>
      </div>

      <div className="grid sm:grid-cols-3 gap-4 mt-2">
        <div className="grid gap-2">
          <Label htmlFor="model">Choose Brand</Label>
          <SelectFinal
            id="make_id"
            value={formProp.make_id}
            setValue={(e: FormEvent<HTMLSelectElement>) =>
              handleFormChange(e, setFormProp)
            }
            resource="makes"
            dataProp="name"
            required={true}
          />
        </div>
        <div className="grid gap-2">
          <Label htmlFor="make_model">Make Model</Label>
          <Input
            id="make_model"
            placeholder="e.g. Focus, Camry..."
            value={formProp.make_model}
            onChange={(e: FormEvent<HTMLInputElement>) =>
              handleFormChange(e, setFormProp)
            }
          />
        </div>
        <div className="grid gap-2">
          <Label htmlFor="make_year">Make Year</Label>
          <Input
            id="make_year"
            type="text"
            placeholder="e.g. 2020"
            value={formProp.make_year}
            onChange={(e: FormEvent<HTMLInputElement>) =>
              handleFormChange(e, setFormProp)
            }
          />
        </div>
      </div>

      <div className="grid sm:grid-cols-2 gap-4 mt-2">
        <div className="grid gap-2">
          <Label htmlFor="license_plate">License Plate</Label>
          <Input
            id="license_plate"
            required
            placeholder="e.g. AU000TT"
            value={formProp.license_plate}
            onChange={(e: FormEvent<HTMLInputElement>) =>
              handleFormChange(e, setFormProp)
            }
          />
        </div>
        <div className="grid gap-2">
          <div className="grid gap-2">
            <Label htmlFor="identification_vin">VIN Number</Label>
            <Input
              id="identification_vin"
              placeholder="e.g XJIUUHH3434889003488"
              value={formProp.identification_vin}
              onChange={(e: FormEvent<HTMLInputElement>) =>
                handleFormChange(e, setFormProp)
              }
              required
            />
          </div>
        </div>
      </div>

      <div className="grid grid-cols-2 sm:grid-cols-3 gap-4">
        <div className="grid gap-2 mt-2">
          <Label>Km Type</Label>
          <RadioGroup
            id="km_type"
            value={formProp.km_type}
            onValueChange={(value: string) =>
              handleFormChange(handleFakeEventChange("km_type", value) as FormEvent<any>, setFormProp)
            }
            className="flex gap-2 mt-1"
          >
            {[
              { value: "km", label: "Km" },
              { value: "miles", label: "Mil" },
            ].map(({ value, label }) => {
              const isSelected = formProp.km_type === value;
              return (
                <div key={value}>
                  <RadioGroupItem
                    value={value}
                    id={`km-type-${value}`}
                    className="hidden"
                  />
                  <Label
                    htmlFor={`km-type-${value}`}
                    className={`
                        px-4 py-2 rounded-md border text-sm font-medium cursor-pointer
                        ${isSelected ? "bg-white" : "bg-muted"} text-muted-foreground
                    `}
                  >
                    {label}
                  </Label>
                </div>
              );
            })}
          </RadioGroup>
        </div>
        <div className="grid gap-2 mt-2">
          <Label>Two Tanks</Label>
          <RadioGroup
            id="two_tanks"
            value={formProp.two_tanks}
            onValueChange={(value: string) =>
              handleFormChange(handleFakeEventChange("two_tanks", value) as FormEvent<any>, setFormProp)
            }
            className="flex gap-2 mt-1"
          >
            {[
              { value: "yes", label: "Yes" },
              { value: "no", label: "No" },
            ].map(({ value, label }) => {
              const isSelected = formProp.two_tanks === value;
              return (
                <div key={value}>
                  <RadioGroupItem
                    value={value}
                    id={`two-tanks-${value}`}
                    className="peer hidden"
                  />
                  <Label
                    htmlFor={`two-tanks-${value}`}
                    className={`
                        px-4 py-2 rounded-md border text-sm font-medium cursor-pointer
                        ${isSelected ? "bg-white" : "bg-muted"} text-muted-foreground
                    `}
                  >
                    {label}
                  </Label>
                </div>
              );
            })}
          </RadioGroup>
        </div>
      </div>

      {formProp.two_tanks == "no" ? (
        <div className="grid grid-cols-2 sm:grid-cols-3 gap-4 mt-2">
          <div className="grid gap-2">
            <Label htmlFor="primaryTankId">Primary Fuel</Label>
            <SelectFinal
              id="primaryTankId"
              value={otherData.primaryTankId}
              setValue={(e: FormEvent<HTMLSelectElement>) =>
                handleFormChange(e, setOtherData || function () {})
              }
              resource="fuel"
              dataProp="name"
              required={true}
            />
          </div>
          <div className="grid gap-2">
            <Label htmlFor="primary_tank_value">Value</Label>
            <Input
              id="primary_tank_value"
              required
              type="number"
              placeholder="e.g. 200 lit or 200 kwh..."
              value={otherData.primary_tank_value}
              onChange={(e: FormEvent<HTMLInputElement>) =>
                handleFormChange(e, setOtherData || function () {})
              }
            />
          </div>
        </div>
      ) : (
        <div>
          <div className="grid grid-cols-2 sm:grid-cols-3 gap-4 mt-2">
            <div className="grid gap-2">
              <Label htmlFor="primaryTankId">Primary Fuel</Label>
              <SelectFinal
                id="primaryTankId"
                value={otherData.primaryTankId}
                setValue={(e: FormEvent<HTMLSelectElement>) =>
                  handleFormChange(e, setOtherData || function () {})
                }
                resource="fuel"
                dataProp="name"
              />
            </div>
            <div className="grid gap-2">
              <Label htmlFor="primary_tank_value">Value</Label>
              <Input
                id="primary_tank_value"
                required
                type="number"
                placeholder="e.g. 200 lit or 200 kwh..."
                value={otherData.primary_tank_value}
                onChange={(e: FormEvent<HTMLInputElement>) =>
                  handleFormChange(e, setOtherData || function () {})
                }
              />
            </div>
          </div>
          <div className="grid grid-cols-2 sm:grid-cols-3 gap-4 mt-4">
            <div className="grid gap-2">
              <Label htmlFor="secondaryTankId">Secondary Fuel</Label>
              <SelectFinal
                id="secondaryTankId"
                value={otherData.secondaryTankId}
                setValue={(e: FormEvent<HTMLSelectElement>) => handleFormChange(e, setOtherData || function() {})}
                resource="fuel"
                dataProp="name"
              />
            </div>
            <div className="grid gap-2">
              <Label htmlFor="secondary_tank_value">Value</Label>
              <Input
                id="secondary_tank_value"
                required
                type="number"
                placeholder="e.g. 200 lit or 200 kwh..."
                value={otherData.secondary_tank_value}
                onChange={(e: FormEvent<HTMLInputElement>) =>
                  handleFormChange(e, setOtherData || function () {})
                }
              />
            </div>
          </div>
        </div>
      )}

      <div className="grid gap-2 mt-2">
        <Label htmlFor="nickname">Nickname</Label>
        <Input
          id="nickname"
          placeholder="Optional nickname"
          value={formProp.nickname}
          onChange={(e: FormEvent<HTMLInputElement>) =>
            handleFormChange(e, setFormProp)
          }
        />
      </div>

      <div className="grid gap-2">
        <Label htmlFor="notes">Notes</Label>
        <Textarea
          id="notes"
          placeholder="Any extra notes..."
          value={formProp.notes}
          onChange={(e: FormEvent<any>) => handleFormChange(e, setFormProp)}
        />
      </div>
    </>
  );
};

export default VehicleForm;
